import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import Table from "../../../../Components/Table";
import { IContrato } from "../../../../Interfaces/Cobranca/Contrato/ContratoInterfaces";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import { Dispatch, SetStateAction } from "react";

const filtroDeTextoTable = textFilter({
    placeholder: "Filtro...",
});

interface ITableNaoDistribuidos {
    lstContratosNaoDistribuidos: Array<IContrato>;
    lstSelecionados: Array<IContrato>;
    setlstSelecionados: Dispatch<SetStateAction<IContrato[]>>;
    ListarContratosNaoDistribuidos: any;
}

function TableNaoDistribuidos(props: ITableNaoDistribuidos) {
    const tableColumns: Array<ColumnDescription<IContrato>> = [
        {
            headerAlign: "center",
            dataField: "ID_EMPRESA",
            text: "Empresa",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "ID_OBRA",
            text: "Obra",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "ID_VENDA",
            text: "Venda",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "DS_CLIENTE",
            text: "Cliente",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "DS_IDENTIFICADOR",
            text: "Quadra/Lote",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "ST_ESCRITURA",
            text: "Status Escritura",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "ST_COBRANCA",
            text: "Status Cobrança",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "NR_PARCELAS_EM_ABERTO",
            text: "Qt. Parc Aberto",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "VL_UNIDADE",
            text: "Vlr. Venda",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "VL_RECEBIDO_VGV",
            text: "Vlr. Recebido",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "VL_PARCELAS_EM_ABERTO",
            text: "Vlr. Parcelas Aberto",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "DS_CLASSIFICACAO_CONTRATO",
            text: "Classificação",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "NR_AGING",
            text: "Aging",
            align: "center",
            filter: filtroDeTextoTable,
        },
    ];

    const selectRowProp: SelectRowProps<IContrato> = {
        mode: "checkbox",
        clickToSelect: true,
        onSelect: (row, isSelect) => {
            row.FL_MARC = isSelect;
            const lstParcelasMarcadas =
                props.lstContratosNaoDistribuidos?.filter((p) => p.FL_MARC) ??
                [];
            props.setlstSelecionados(lstParcelasMarcadas);
        },
        onSelectAll: (isSelect, rows: Array<IContrato>) => {
            rows.forEach((row) => {
                row.FL_MARC = isSelect;
            });
            const lstParcelasMarcadas =
                props.lstContratosNaoDistribuidos?.filter((p) => p.FL_MARC) ??
                [];
            props.setlstSelecionados(lstParcelasMarcadas);
        },
        selected: props.lstSelecionados.map((selecionados) => {
            return selecionados.ID_CASO_COBRANCA_FATO;
        }),
    };

    return (
        <Table
            columns={tableColumns}
            data={props.lstContratosNaoDistribuidos}
            keyField="ID_CASO_COBRANCA_FATO"
            selectRow={selectRowProp}
            loading={props.ListarContratosNaoDistribuidos.loading}
            rowClasses="checkbox-table"
            noDataIndication={
                <div className="text-center text-black-50">
                    Nenhum contrato não distribuído encontrado
                </div>
            }
            striped={true}
            bordered={true}
            filter={filterFactory()}
        />
    );
}

export default TableNaoDistribuidos;
